import { coreInitiativesGetAsyncSlice } from './get';
import { CoreInitiativesName } from './name';
import { deleteInitiatives } from '@api';
import { PaginationDirection } from '@sonar-software/sonar-ts-types';
import { createDeleteAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreInitiativesDeleteAsyncSlice = createDeleteAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [
			() =>
				coreInitiativesGetAsyncSlice.asyncActionCreators.repeatGetCoreInitiatives((previous) => ({
					...previous,
					key: '',
					paginationDirection: PaginationDirection.Forward
				}))
		]
	},
	name: CoreInitiativesName,
	receive: false,
	request: true,
	requestHandler: deleteInitiatives,
	yieldType: SagaYieldType.Every
});
